import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../setup/store';
import { useAppSelector } from '../setup/hooks';

export const logisticsTenant = {
    VW_RIO_DEV: 'vw.rio-dev',
    VW_QA: 'vw.qa',
    VW_PROD: 'vw.prod',
};
export type LogisticsTenant = (typeof logisticsTenant)[keyof typeof logisticsTenant];

export type UserProfile = {
    sub?: string;
    azp?: string;
    account?: string;
    tenant?: string;
    logisticsTenant?: LogisticsTenant;
    givenName?: string;
    familyName?: string;
    name?: string;
    locale?: string;
    email?: string;
};

export type LoginState = {
    hasUserSessionEverExpired: boolean;
    userProfile: UserProfile | null;
    userSessionExpired: boolean;
};

const initialState: LoginState = {
    hasUserSessionEverExpired: false,
    userProfile: null,
    userSessionExpired: false,
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        userProfileObtained: (state, action: PayloadAction<UserProfile>) => {
            state.userProfile = action.payload;
        },
        userSessionExpired: state => {
            state.hasUserSessionEverExpired = true;
            state.userSessionExpired = true;
        },
        userSessionRenewed: state => {
            state.userSessionExpired = false;
        },
    },
});

// Other code such as selectors can use the imported `RootState` type
export const getUserProfile = (state: RootState) => state.login.userProfile;
export const getUserAccount = (state: RootState) => state.login.userProfile?.account;
export const getUserTenant = (state: RootState) => state.login.userProfile?.tenant;

export const hasUserSessionEverExpired = (state: RootState) => state.login.hasUserSessionEverExpired;
export const isUserSessionExpired = (state: RootState) => state.login.userSessionExpired;

export const useUserProfile = () => useAppSelector(getUserProfile);
export const useUserAccount = () => useAppSelector(getUserAccount);

export const useIsUserSessionExpired = () => useAppSelector(isUserSessionExpired);
